import React, { useState, useEffect } from 'react';

const BlinkingCursor = ({ text, className = "" }) => {
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 600); // Blink every 600ms for professional look

    return () => clearInterval(interval);
  }, []);

  return (
    <span className={className}>
      {text}
      <span 
        className={`inline-block w-1 ml-1 bg-emerald-400 transition-opacity duration-100 ${
          showCursor ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ height: '1.2em' }}
      >
        |
      </span>
    </span>
  );
};

export default BlinkingCursor;